export class CentricPoItemVariant {

    size: string;
    upc: string;
    label:string;
    unitPrice: string;
    quantity: string;
    amount: string;
    exFactory:string;
    exPort:string;
    deliveryDate:string;
    retialPrice:string;


    comptMaterial:string;
    ratio:string;

    eachPerCarton:string;


   
}